import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PropertySelectorComponent } from './property-selector.component';
import { PropertyNodeComponent } from './property-node/property-node.component';
import { RICSMenuModule } from '../../../../../../../../../../common/components/menu/menu.module';
import { LunaCommonModule } from '../../../../../../../../../../common/common.module';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [PropertySelectorComponent, PropertyNodeComponent],
    imports: [
        CommonModule,
        FormsModule,
        RICSMenuModule,
        LunaCommonModule
    ],
    exports: [PropertySelectorComponent, PropertyNodeComponent]
})
export class PropertySelectorModule { }
